import { infiniteQueryOptions } from "@tanstack/react-query";
import api from "~/shared/api/core/api";
import { Params } from "~/shared/api/types/params";
import { createInfinitePaginationConfig } from "~/shared/util/createInfinitePaginationConfig";

export const LOCATIONS_KEYS = {
  all: ["locations"] as const,
  list: (params: Params) => [...LOCATIONS_KEYS.all, "filter", params] as const,
  filter: (params: Params) => [...LOCATIONS_KEYS.all, "filter", params] as const,
};

export const LOCATIONS_QUERIES = {
  infiniteList: (params: { [key: string]: unknown }) => {
    const paginationConfig = createInfinitePaginationConfig(params, 20);

    return infiniteQueryOptions({
      queryFn: async ({ pageParam = 1, signal }) => {
        const response = await api.get(`/locations`, {
          params: paginationConfig.queryFnParams(pageParam),
          signal,
        });

        return response.data;
      },
      queryKey: LOCATIONS_KEYS.list({
        params: paginationConfig.keyParams,
      }),
      ...paginationConfig.opts,
    });
  },
};
